export default class Header {
  constructor(element) {
    this.element = element;
    this.scrollLimit = parseFloat(this.element.dataset.threshold || 0.1);
    this.scrollPosition = 0;
    this.lastScrollPosition = 0;
    this.html = document.documentElement;
    this.toggle = this.element.querySelector('.js-toggle');
    // Seul le lien de langue ouvre son sous-menu au clic; Services et À propos naviguent vers leur page
    this.submenuLinks = this.element.querySelectorAll('.header__item--language.header__item--has-submenu > .header__link');
    this.submenuToggles = this.element.querySelectorAll('[data-nav-submenu-toggle]');
    this.resizeObserver = null;

    this.changeMenuImages();
    this.setLayoutMode();
    this.setHeaderHeight();
    this.init();
    this.initNavMobile();
    this.initSubmenus();
    this.initResizeObserver();
  }

  setLayoutMode() {
    if (this.element.dataset.header) {
      this.element.classList.add(...this.element.dataset.header.split(' ').filter(Boolean));
    }
  }

  init() {
    if ('autoHide' in this.element.dataset && !this.element.classList.contains('header-vertical')) {
      window.addEventListener('scroll', this.onScroll.bind(this));
    }
  }

  initResizeObserver() {
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => {
        this.setHeaderHeight();
      });
      this.resizeObserver.observe(this.element);
      return;
    }

    window.addEventListener('resize', this.setHeaderHeight.bind(this));
  }

  setHeaderHeight() {
    this.element.style.setProperty('--header-height', `${this.element.offsetHeight}px`);
  }

  onScroll() {
    this.lastScrollPosition = this.scrollPosition;
    this.scrollPosition = document.scrollingElement.scrollTop;

    this.setHeaderState();
    this.setDirections();
  }

  setHeaderState() {
    const threshold = document.scrollingElement.scrollHeight * this.scrollLimit;

    if (this.scrollPosition <= threshold || this.scrollPosition < this.lastScrollPosition) {
      this.html.classList.remove('header-is-hidden');
    } else {
      this.html.classList.add('header-is-hidden');
    }
  }

  setDirections() {
    if (this.scrollPosition >= this.lastScrollPosition) {
      this.html.classList.remove('is-scrolling-up');
      this.html.classList.add('is-scrolling-down');
    } else {
      this.html.classList.add('is-scrolling-up');
      this.html.classList.remove('is-scrolling-down');
    }
  }

  initNavMobile() {
    if (!this.toggle) {
      return;
    }

    this.toggle.addEventListener('click', this.onToggleNav.bind(this));
    document.addEventListener('click', this.onDocumentClick.bind(this));
    document.addEventListener('keydown', this.onKeydown.bind(this));
  }

  onToggleNav() {
    const isOpen = this.html.classList.toggle('nav-is-active');

    this.setHeaderHeight();
    this.toggle.setAttribute('aria-expanded', isOpen);
  }

  initSubmenus() {
    for (let i = 0; i < this.submenuLinks.length; i++) {
      this.submenuLinks[i].addEventListener('click', this.onToggleSubmenu.bind(this));
    }

    for (let i = 0; i < this.submenuToggles.length; i++) {
      this.submenuToggles[i].addEventListener('click', this.onToggleSubmenu.bind(this));
    }
  }

  onToggleSubmenu(event) {
    event.preventDefault();

    const control = event.currentTarget;
    const item = control.closest('.header__item');
    const toggle = item.querySelector('[data-nav-submenu-toggle]');

    this.closeSubmenus(item);

    const isOpen = item.classList.toggle('is-open');

    if (toggle) {
      toggle.setAttribute('aria-expanded', isOpen);
    }
  }

  onDocumentClick(event) {
    if (this.element.contains(event.target)) {
      return;
    }

    this.closeNavigation();
    this.closeSubmenus();
  }

  onKeydown(event) {
    if (event.key !== 'Escape') {
      return;
    }

    this.closeNavigation();
    this.closeSubmenus();
  }

  closeNavigation() {
    this.html.classList.remove('nav-is-active');

    if (this.toggle) {
      this.toggle.setAttribute('aria-expanded', false);
    }
  }

  closeSubmenus(exceptItem = null) {
    for (let i = 0; i < this.submenuToggles.length; i++) {
      const toggle = this.submenuToggles[i];
      const item = toggle.closest('.header__item');

      if (item === exceptItem) {
        continue;
      }

      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', false);
    }
  }

  changeMenuImages() {
    const dropmenus = this.element.querySelectorAll("[data-dropmenu]");

    for(let menuIndex = 0;menuIndex<dropmenus.length;menuIndex++) {
      const images = Array.from(dropmenus[menuIndex].querySelector("[data-dropmenu-media]").children);
      const links = dropmenus[menuIndex].querySelector("[data-dropmenu-links]").querySelectorAll('[data-dropmenu-link]');

      if(images[0])
        images[0].classList.add("img-active");

      for(let i = 0;i<links.length;i++) {
        links[i].addEventListener("mouseenter", () => {
          if(images[i]) {
            for(let imageIndex = 0;imageIndex<images.length;imageIndex++)
              images[imageIndex].classList.remove("img-active");
            images[i].classList.add("img-active");
          }
        });
      }
    }
  }
}
